import React from "react";
import { Plus, Trash2 } from "lucide-react";
import AirportSelect from "@/components/AirportSelect";
import AirlineSelect from "@/components/AirlineSelect";
import DateTimePicker from "@/components/DateTimePicker";
import { F } from "../_shared";

export default function StepFlights({ q, setQ }) {
  const add = () => setQ((p) => ({ ...p, flights: [...p.flights, { airline:"", flight_number:"", dep_airport:"", arr_airport:"", dep_datetime:"", arr_datetime:"", cabin:"Economy", baggage:"", remarks:"" }] }));
  const upd = (i, k, v) => setQ((p) => ({ ...p, flights: p.flights.map((f, idx) => idx===i ? {...f, [k]:v} : f) }));
  const rem = (i) => setQ((p) => ({ ...p, flights: p.flights.filter((_, idx) => idx !== i) }));
  return (
    <>
      <div className="space-y-4">
        {q.flights.map((f, i) => (
          <div key={i} className="border border-border rounded p-4">
            <div className="flex items-center justify-between mb-3">
              <div className="overline text-[10px]">Flight {i+1}</div>
              <button data-testid={`flight-remove-${i}`} onClick={()=>rem(i)} className="text-red-500 hover:text-red-700"><Trash2 size={14} /></button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <AirlineSelect label="Airline" value={f.airline} onChange={(v)=>upd(i, "airline", v)} testid={`flight-airline-${i}`} />
              <F label="Flight Number" value={f.flight_number} onChange={(v)=>upd(i, "flight_number", v)} testid={`flight-num-${i}`} />
              <AirportSelect label="From Airport" value={f.dep_airport} onChange={(v)=>upd(i, "dep_airport", v)} testid={`flight-from-${i}`} />
              <AirportSelect label="To Airport" value={f.arr_airport} onChange={(v)=>upd(i, "arr_airport", v)} testid={`flight-to-${i}`} />
              <DateTimePicker label="Departure Date & Time" value={f.dep_datetime} onChange={(v)=>upd(i, "dep_datetime", v)} testid={`flight-dep-${i}`} />
              <DateTimePicker label="Arrival Date & Time" value={f.arr_datetime} onChange={(v)=>upd(i, "arr_datetime", v)} testid={`flight-arr-${i}`} />
              <F label="Cabin" value={f.cabin} onChange={(v)=>upd(i, "cabin", v)} testid={`flight-cabin-${i}`} />
              <F label="Baggage" value={f.baggage} onChange={(v)=>upd(i, "baggage", v)} testid={`flight-bag-${i}`} />
            </div>
            <div className="mt-3">
              <F label="Remarks" value={f.remarks} onChange={(v)=>upd(i, "remarks", v)} testid={`flight-remarks-${i}`} />
            </div>
          </div>
        ))}
      </div>
      <button data-testid="flight-add-btn" onClick={add} className="mt-4 inline-flex items-center gap-2 text-sm px-3 py-2 border border-dashed border-slate-300 rounded hover:border-[#16A34A] hover:text-[#16A34A]"><Plus size={14} /> Add flight</button>
    </>
  );
}
